import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Box } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import "./edit-text.scss";
import { updateCard } from "../../../../../../sevices/apiCards";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import { RFHTextField } from "../../../../../../components/RFH";
import useMutate from "../../../../../../hooks/useMutate";

function EditTitle({ title, cardId, hasEditCardPermission, id }) {
  // const {
  //   board: { board_id: id },
  // } = data;
  const queryClient = useQueryClient();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const isMobile = useResponsive("down", "md");
  const schema = yup.object().shape({
    title: yup
      .string()
      .max(255, "Character limit exceeded! Maximum 255 characters allowed."),
  });

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState,
    setValue,
    ...methods
  } = useForm({
    defaultValues: {
      title: title,
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    setValue("title", title);
  }, [cardId, title]);

  const { mutate } = useMutate(updateCard, 
    ["mineCards", "watching"], 
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["card", String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: ["history", String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: ["cards", String(id)],
      });
      setLoading(false);
    },
    () => {
      setLoading(false);
    },
  );
  const detailTitle = useMemo(() => (
    title ? title.charAt(0).toUpperCase() + title.slice(1) : ""
  ), [title]);

  const submit = useCallback((data) => {
    setOpen(false);
    setLoading(true);
    if (data.title !== title) {
      mutate({
        card_id: cardId,
        data,
      });
    }
  }, [cardId, title, mutate]);

  const openField = useCallback(() => {
    if (hasEditCardPermission) {
      setOpen(true);
    }
  }, [hasEditCardPermission]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(submit)();
    }
  }, [handleSubmit, submit]);

  return (
    <>
      {open && hasEditCardPermission ? (
        <>
          <FormProvider {...methods}>
            <Box
              component="form"
              onSubmit={handleSubmit(submit)}
              noValidate
              className="edit-board-field-name"
              onBlur={handleSubmit(submit)}
              onKeyDown={handleKeyDown}>
              <RFHTextField
                className="edit-text edit-text-title-field"
                required
                fullWidth
                multiline
                size="small"
                id="title"
                name="title"
                defaultPadding={false}
                autoFocus
              />
            </Box>
          </FormProvider>
        </>
      ) : (
        <p
          className={isMobile ? "mobile-edit-text" : "edit-text"}
          onClick={openField}>
          {detailTitle}
        </p>
      )}
    </>
  );
}

export default React.memo(EditTitle);
